import {USER_ROLES} from "@/constants";

export default class AddressPolicy
{
    /**
     * Determine whether the user can view any models.
     *
     * @param  {object}  user
     * @return mixed
     */
    viewAny(user)
    {
        return true;
    }

    /**
     * Determine whether the user can view the model.
     *
     * @param  {object}  user
     * @param  {object}  address
     * @return {mixed}
     */
    view(user, address)
    {
        return true;
    }

    /**
     * Determine whether the user can create models.
     *
     * @param  {object}  user
     * @return {mixed}
     */
    create(user)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER].includes(user.role);
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  address
     * @return {mixed}
     */
    update(user, address)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER].includes(user.role);
    }

    /**
     * Determine whether the user can restore the model.
     *
     * @param  {object}  user
     * @param  {object}  address
     * @return {mixed}
     */
    restore(user, address)
    {
        return [USER_ROLES.ADMIN].includes(user.role);
    }

    /**
     * Determine whether the user can delete the model.
     *
     * @param  {object}  user
     * @param  {object}  address
     * @return {mixed}
     */
    delete(user, address)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER].includes(user.role);
    }

    /**
     * Determine whether the user can permanently delete the model.
     *
     * @param  {object}  user
     * @param  {object}  address
     * @return {mixed}
     */
    forceDelete(user, address)
    {
        return [USER_ROLES.ADMIN].includes(user.role);
    }
}
